import { api } from '../commonApi';
import { ICreateTableSessionRequest, IGetTableSessionResponse } from '../../proto/table/tableSession';
import { setAuthState } from '../auth/authSlice';

const BASE_RESTAURANT_URL = `/table`;

export const tableApi = api.injectEndpoints({
	endpoints: (builder) => ({
		startTableSession: builder.mutation<IGetTableSessionResponse, ICreateTableSessionRequest>({
			query: ({ tableId }) => ({
				url: `${BASE_RESTAURANT_URL}/startSession/${tableId}`,
				method: 'POST',
			}),
			onQueryStarted: async (props, { dispatch, queryFulfilled }) => {
				const { data } = await queryFulfilled;

				dispatch(setAuthState({ tableSessionId: data.id, restaurantId: data.restaurantId }));
			},
		}),
	}),
});

export const { useStartTableSessionMutation } = tableApi;
